export default __webpack_public_path__ + "1b5b8412d55b8439341effcfdbe350f3.ttf";